import { get } from 'lodash';

export function getUrlSegment(route, children = false): string {
  return get(route, children ? 'firstChild.snapshot.url[0].path' : 'parent.snapshot.url[0].path') as string;
}
